<script>
export default {
  props: {
    nama_kompetensi: String,
    level: String,
    proctoringConfiguration: Object,
    progressSaveData: Boolean,
    infoPengerjaan: Function,
    tipe: String,
    formattedTime: String,
    faceAlertMessage: String,
  },
  emits: ['stopAutoProctor', 'showProgress']
}
</script>


<template>
  <div class="mym-quizz-header" ref="quizHeader">
    <div class="mym-quizz-navbar mb-1">
      <div class="mym-information">
        <div class="mym-navbar-logo">
          <img src="/logo_pln.png" alt="Logo PLN" style="width: 100%; height: 100%; object-fit: contain;" />
        </div>
        <div>
          <h4 class="title-navbar-information mb-0">ASESMEN HARD COMPETENCY</h4>
          <span class="sub-title-navbar-information me-2">
            {{ nama_kompetensi }}
          </span>
          <span class="mym-badge mym-soft-badge-primary">Level {{ level }}</span>
        </div>
      </div>

      <div class="mym-navigation text-end">
        <!-- <b-button
          v-if="proctoringConfiguration.used"
          variant="danger"
          @click="$emit('stopAutoProctor')"
        >
          <i class="fa fa-stop me-1"></i>
          Stop Proctor
        </b-button> -->

        <b-button
          variant="outline-secondary"
          type="button"
          @click="infoPengerjaan(tipe)"
          size="sm"
        >
          <i class="far fa-question-circle"></i>
          Petunjuk
        </b-button>

        <b-button
          class="mym-nav-button"
          type="button"
          variant="primary"
          size="sm"
          @click="$emit('showProgress')"
        >
          <i class="fas fa-th-large"></i>
          Lihat Progress
        </b-button>
      </div>
    </div>

    <div class="mym-sub-navbar">
      <span>
        <span v-if="progressSaveData === null">&nbsp;</span>
        <span v-else-if="progressSaveData" class="text-success fw-bold">
          <i class="fa fa-check me-1"></i>
          Tersimpan
        </span>
        <span v-else class="fw-bold">
          <i class="fa fa-spin fa-spinner me-1"></i>
          Proses
        </span>
        <span v-if="faceAlertMessage" class="text-danger fw-bold ms-2">
          <i class="fa fa-exclamation-triangle me-1"></i>
          {{ faceAlertMessage }}
        </span>
      </span>

      <div class="mym-timer">
        <i class="far fa-clock timer-icon"></i>
        <div class="mym-timer-information text-center">
          <div class="mb-0">Waktu Tersisa</div>
          <div class="mym-time-counting">
            {{ formattedTime }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>